import React, { useState, useEffect } from 'react';
import {
    getBankDetails,
    updateBankDetails
} from '../services/poojariService';
import { toast } from 'react-toastify';
import axios from 'axios';

const RED = '#B22222';
const DARK_RED = '#8B0000';
const GOLD = '#FFD700';

/**
 * ============================================================
 * BANK DETAILS - poojari ka payout account
 * ============================================================
 *
 * ⚠️ REGISTRATION MEIN KYUN NAHI MAANGTE:
 *
 * Pehli screen pe bank account maangna logon ko bhaga deta hai.
 * Aur us waqt poojari verify bhi nahi hua hota - uska account
 * approve hi nahi hua, to paisa aane ka sawal hi nahi.
 *
 * Isliye ye alag section hai, jab chahe bhare.
 *
 * ⚠️ PROFILE FORM MEIN KYUN NAHI DAALA:
 *
 * Do wajah:
 *   1. Profile form pehle se lamba hai (services, languages,
 *      address). Bank details bharne ke liye poora form save
 *      karna padta.
 *   2. Bank details ALAG API se jaati hai (updateBankDetails).
 *      Ek form mein do API call = galti ki jagah.
 *
 * ⚠️ ACCOUNT NUMBER MASKED AATA HAI:
 *
 * Backend poora account number kabhi wapas nahi bhejta - sirf
 * "****4521". Ye jaan-boojh ke hai: agar kisi ka session churaya
 * gaya to uska poora account number na dikhe.
 *
 * Isliye edit karte waqt purana number dikha NAHI sakte - poojari
 * ko dobara poora likhna padega. Ye UI mein saaf likha hai warna
 * wo samjhega data kho gaya.
 */
const BankDetailsSection = ({ poojariId }) => {

    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);
    // IFSC se bank/branch ka naam — poojari galti turant pakad le
    const [ifscInfo, setIfscInfo] = useState(null);
    const [ifscChecking, setIfscChecking] = useState(false);

    const [form, setForm] = useState({
        accountHolderName: '',
        bankAccountNumber: '',
        confirmAccountNumber: '',
        ifscCode: '',
        pan: ''
    });

    useEffect(() => {
        if (poojariId) {
            fetchDetails();
        }
        // eslint-disable-next-line
    }, [poojariId]);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const data = await getBankDetails(poojariId);
            setDetails(data);
        } catch (err) {
            // ⚠️ Bank details na hona koi ERROR nahi hai - naya
            // poojari abhi tak bhara hi nahi hoga. Toast dikhana
            // bura hoga.
            setDetails(null);
        } finally {
            setLoading(false);
        }
    };

        // ============================================================
    // IFSC LOOKUP
    //
    // Poojari IFSC daalta hai to bank aur branch ka naam dikha
    // dete hain. Isse galat IFSC turant pakda jaata hai - warna
    // wo Save dabata, Razorpay mana karta, aur usko samajh nahi
    // aata ki kya galat hai.
    //
    // ⚠️ ye call `api` se NAHI ja rahi, seedha axios se - kyunki
    //    api.js har request pe HAMARA TOKEN lagata hai, aur wo
    //    token kisi bahar wali API ko bhejna galat hai.
    //
    // ⚠️ ifsc.razorpay.com free aur public hai - koi key nahi
    //    chahiye.
    // ============================================================
    useEffect(() => {
        const code = (form.ifscCode || '').trim().toUpperCase();

        // Poora IFSC hi nahi bana - abhi kuch mat karo
        if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(code)) {
            setIfscInfo(null);
            return;
        }

        let alive = true;
        setIfscChecking(true);

        // ⚠️ 400ms ruk ke - poojari type kar raha ho to har akshar
        //    pe call na jaaye
        const timer = setTimeout(() => {
            axios.get(`https://ifsc.razorpay.com/${code}`)
                .then(res => {
                    if (alive) {
                        setIfscInfo({
                            ok: true,
                            bank: res.data.BANK,
                            branch: res.data.BRANCH
                        });
                    }
                })
                .catch(() => {
                    // ⚠️ 404 matlab IFSC hai hi nahi. Baaki koi bhi
                    //    error (network, unka server down) bhi yahin
                    //    aata hai - isliye message aisa rakha hai jo
                    //    dono mein theek lage. "Galat IFSC" likh dete
                    //    to network toot-ne pe poojari bekaar mein
                    //    sahi IFSC badalta rehta.
                    if (alive) setIfscInfo({ ok: false });
                })
                .finally(() => {
                    if (alive) setIfscChecking(false);
                });
        }, 400);

        return () => {
            alive = false;
            clearTimeout(timer);
        };
    }, [form.ifscCode]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        // ⚠️ IFSC aur PAN hamesha CAPITAL - backend ka regex
        // sirf capital maanta hai. Poojari chhote mein likhega
        // aur server reject kar dega, jo bekaar ka jhanjhat hai.
        if (name === 'ifscCode' || name === 'pan') {
            setForm({ ...form, [name]: value.toUpperCase() });
            return;
        }

        // Account number sirf ankein
        if (name === 'bankAccountNumber'
            || name === 'confirmAccountNumber') {
            setForm({ ...form, [name]: value.replace(/\D/g, '') });
            return;
        }

        setForm({ ...form, [name]: value });
    };

    const handleSave = async () => {

        // ⚠️ Wahi rules jo backend mein hain. Yahan check karne
        // se poojari ko server tak jaake error nahi khana padta.

        if (!form.accountHolderName.trim()) {
            return toast.warning('Enter account holder name');
        }

        if (!/^[0-9]{9,18}$/.test(form.bankAccountNumber)) {
            return toast.warning(
                'Account number must be 9 to 18 digits');
        }

        // ⚠️ YE CHECK SABSE ZAROORI HAI.
        //
        // Account number ek digit galat hua to paisa KISI AUR ke
        // paas chala jaayega, aur wapas nahi aayega. Isliye do
        // baar likhwate hain.
        if (form.bankAccountNumber !== form.confirmAccountNumber) {
            return toast.warning('Account numbers do not match');
        }

        if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifscCode)) {
            return toast.warning(
                'Enter a valid IFSC code (e.g. SBIN0001234)');
        }

        if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(form.pan)) {
            return toast.warning(
                'Enter a valid PAN (e.g. ABCDE1234F)');
        }

        setSaving(true);
        try {
            await updateBankDetails(poojariId, form);
            toast.success('Bank details saved');
            setEditing(false);
            setForm({
                accountHolderName: '',
                bankAccountNumber: '',
                confirmAccountNumber: '',
                ifscCode: '',
                pan: ''
            });
            fetchDetails();
        } catch (err) {
            toast.error(err.response?.data?.message
                || 'Could not save bank details');
        } finally {
            setSaving(false);
        }
    };

    const label = {
        color: DARK_RED,
        fontSize: '12px',
        fontWeight: 600,
        marginBottom: '3px',
        display: 'block'
    };

    const input = {
        borderColor: GOLD,
        borderRadius: '8px',
        fontSize: '14px'
    };

    if (loading) {
        return null;
    }

    return (
        <div className="p-3 mb-3"
            style={{
                backgroundColor: 'white',
                border: `1px solid ${GOLD}`,
                borderRadius: '12px'
            }}>

            <div className="d-flex justify-content-between align-items-center mb-1">
                <h6 className="mb-0"
                    style={{ color: DARK_RED, fontWeight: 700 }}>
                    Bank account
                </h6>
                {!editing && (
                    <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{
                            color: RED,
                            fontSize: '13px',
                            fontWeight: 600,
                            textDecoration: 'none'
                        }}
                        onClick={() => setEditing(true)}>
                        {details?.hasBankDetails ? 'Change' : 'Add'}
                    </button>
                )}
            </div>

            {!editing ? (
                <>
                    {details?.hasBankDetails ? (
                        <div style={{ fontSize: '13px' }}>
                            <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">Name</span>
                                <span>{details.accountHolderName}</span>
                            </div>
                            <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">Account</span>
                                <span>{details.bankAccountNumber}</span>
                            </div>
                            <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">IFSC</span>
                                <span>{details.ifscCode}</span>
                            </div>
                            {details.pan && (
                                <div className="d-flex justify-content-between py-1">
                                    <span className="text-muted">PAN</span>
                                    <span>{details.pan}</span>
                                </div>
                            )}
                            {/* ⚠️ VERIFICATION KA STATUS.
                                Iske bina poojari ko lagta hai ki
                                details save ho gayi to kaam ho gaya.
                                Asal mein Razorpay use review karta
                                hai (1-2 din), aur reject bhi kar
                                sakta hai. */}
                            {details.verificationStatus && (
                                <div className="mt-2 p-2"
                                                                        style={{
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        backgroundColor:
                                            details.razorpayLinked
                                                ? '#E8F5E9'
                                                : details.verificationStatus
                                                    === 'FAILED'
                                                    ? '#FFEBEE'
                                                    : '#FFF8E1',
                                        color:
                                            details.razorpayLinked
                                                ? '#2E7D32'
                                                : details.verificationStatus
                                                    === 'FAILED'
                                                    ? '#C62828'
                                                    : '#8D6E00'
                                    }}>
                                    {/* ⚠️ NEEDS_CLARIFICATION yahan se
                                        HATA diya hai — jaan-boojh ke.

                                        Wo FAILED se alag hai: account ban
                                        chuka hai, bank details Razorpay
                                        tak pahunch chuki hain, penny drop
                                        bhi ho jaata hai. Razorpay ko bas
                                        kuch aur chahiye.

                                        Laal "failed" dikhane se poojari
                                        apni SAHI details baar-baar
                                        badalta rahega aur haar maan
                                        lega. Ab wo peela "in progress"
                                        dikhta hai, jo sach hai. */}
                                    <div className="fw-bold">
                                        {details.razorpayLinked
                                            ? 'Bank account verified'
                                            : details.verificationStatus
                                                === 'FAILED'
                                                ? 'Verification failed'
                                                : 'Verification in progress'}
                                    </div>
                                    <div>{details.message}</div>

                                    {/* ⚠️ Razorpay ki asli wajah.
                                        Iske bina poojari wahi galat
                                        detail dobara daalta rahega. */}
                                    {details.verificationError && (
                                        <div className="mt-1"
                                            style={{ fontSize: '11px' }}>
                                            {details.verificationError}
                                        </div>
                                    )}
                                </div>
                            )}
                            </div>
                    ) : (
                        <p className="mb-0"
                            style={{ fontSize: '12px', color: '#888' }}>
                            Add your bank account to receive online
                            payments. Please double-check the details.
                        </p>
                    )}
                </>
            ) : (
                <>
                    {/* ⚠️ Ye line zaroori hai. Backend masked number
                        lautata hai, isliye purana number form mein
                        bhar nahi sakte. Bina bataye poojari sochega
                        ki uska data kho gaya. */}
                    {details?.hasBankDetails && (
                        <p style={{
                            fontSize: '11px',
                            color: '#8A5300',
                            backgroundColor: '#FFF8E1',
                            padding: '7px 9px',
                            borderRadius: '7px'
                        }}>
                            For your security we never show the full
                            account number. Please enter all details
                            again.
                        </p>
                    )}

                    <div className="mb-2">
                        <label style={label}>
                            Account holder name
                        </label>
                        <input
                            type="text"
                            name="accountHolderName"
                            className="form-control"
                            style={input}
                            value={form.accountHolderName}
                            onChange={handleChange}
                            placeholder="As printed on passbook"
                            disabled={saving} />
                    </div>

                    <div className="mb-2">
                        <label style={label}>
                            Account number
                        </label>
                        <input
                            type="text"
                            name="bankAccountNumber"
                            className="form-control"
                            style={input}
                            value={form.bankAccountNumber}
                            onChange={handleChange}
                            maxLength={18}
                            placeholder="9 to 18 digits"
                            disabled={saving} />
                    </div>

                    <div className="mb-2">
                        <label style={label}>
                            Re-enter account number
                        </label>
                        <input
                            type="text"
                            name="confirmAccountNumber"
                            className="form-control"
                            style={input}
                            value={form.confirmAccountNumber}
                            onChange={handleChange}
                            maxLength={18}
                            placeholder="Type it again"
                            disabled={saving}
                            onPaste={(e) => e.preventDefault()} />
                        {/* ⚠️ Paste band kiya hai - jaan-boojh ke.
                            Copy-paste karne se galti pakdi hi nahi
                            jaayegi, aur poora point yahi tha. */}
                    </div>

                    <div className="mb-2">
                        <label style={label}>
                            IFSC code
                        </label>
                        <input
                            type="text"
                            name="ifscCode"
                            className="form-control"
                            style={input}
                            value={form.ifscCode}
                            onChange={handleChange}
                            maxLength={11}
                            placeholder="SBIN0001234"
                            disabled={saving} />
                            
                        {/* ⚠️ IFSC ka natija. Poojari yahan bank ka
                            naam dekh ke turant samajh jaata hai ki
                            sahi code daala ya nahi — Save dabane se
                            pehle hi. */}
                        {ifscChecking && (
                            <div style={{
                                fontSize: '11px',
                                color: '#888',
                                marginTop: '4px'
                            }}>
                                Checking...
                            </div>
                        )}
                        {!ifscChecking && ifscInfo?.ok && (
                            <div style={{
                                fontSize: '11px',
                                color: '#2E7D32',
                                marginTop: '4px'
                            }}>
                                {ifscInfo.bank} — {ifscInfo.branch}
                            </div>
                        )}
                        {!ifscChecking && ifscInfo && !ifscInfo.ok && (
                            <div style={{
                                fontSize: '11px',
                                color: '#C62828',
                                marginTop: '4px'
                            }}>
                                Could not find this IFSC code. Please
                                check it.
                            </div>
                        )}
                    </div>

                    <div className="mb-3">
                        <label style={label}>
                            PAN
                        </label>
                        <input
                            type="text"
                            name="pan"
                            className="form-control"
                            style={input}
                            value={form.pan}
                            onChange={handleChange}
                            maxLength={10}
                            placeholder="ABCDE1234F"
                            disabled={saving} />
                        <small style={{
                            fontSize: '11px',
                            color: '#888'
                        }}>
                            Required by the payment provider for
                            payouts.
                        </small>
                    </div>

                    <div className="d-flex gap-2">
                        <button
                            type="button"
                            className="btn flex-fill fw-bold"
                            style={{
                                backgroundColor: RED,
                                color: GOLD,
                                border: 'none',
                                borderRadius: '9px',
                                fontSize: '14px'
                            }}
                            onClick={handleSave}
                            disabled={saving}>
                            {saving ? 'Saving...' : 'Save'}
                        </button>
                        <button
                            type="button"
                            className="btn"
                            style={{
                                border: `1px solid ${GOLD}`,
                                borderRadius: '9px',
                                color: '#888',
                                fontSize: '14px'
                            }}
                            onClick={() => setEditing(false)}
                            disabled={saving}>
                            Cancel
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default BankDetailsSection;